import axios from 'axios';
import { api, headers } from '../../app/conf';
import { makeQuery } from "../../shared/helpers/commons";

export const getStores = (filters, token) => {
    return axios({
        method: 'get',
        url: `${api}/warehouses?${makeQuery(filters)}`,
        headers: {
            ...headers,
            "X-Access-Token": token
        }
    });
};

export const createStore = (store, token) => {
    return axios({
        method: 'post',
        url: `${api}/warehouses`,
        headers: {
            ...headers,
            "X-Access-Token": token
        },
        data: store
    });
};

export const createStoresBatch = (stores, token) => {
    axios({
        method: 'post',
        url: `${api}/warehouses/batch`,
        headers: {
            "Content-Type": "application/json",
            "X-Access-Token": token
        },
        data: stores
    });
};

export const updateStore = (store, token) => {
    axios({
        method: 'put',
        url: `${api}/warehouses/${store._id}`,
        headers: {
            ...headers,
            "X-Access-Token": token
        },
        data: store
    });
};

export const testEmail = (data, token) => {
    return axios({
        method: 'post',
        url: `${api}/warehouses/test-email`,
        headers: {
            ...headers,
            "X-Access-Token": token
        },
        data: data
    });
};
